export const toArray = <T>(values: T | T[] | (string | undefined)): undefined | T[] => {
  if (typeof values === 'string' || typeof values !== 'object') return undefined;

  return Array.isArray(values) ? values : [values];
};
